export default __webpack_public_path__ + "static/media/azul.30c35a75.jpg";